import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

export const StExploreYourProfileWrapper = styled(Box)(() => ({
  boxShadow: '0px 4px 4px 0px #00000040',
  border: '1px solid #00000040',
  borderRadius: '8px',
  padding: '24px 20px',
}));

export const StExploreYourProfileTitle = styled(Typography)(() => ({
  height: '89px',
  alignItems: 'left',
}));

export const StExploreYourProfileStack = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  '& .MuiTypography-subtitle1': {
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiButton-containedPrimary': {
    minWidth: '212px',
  },
  [theme.breakpoints.down('md')]: {
    '& .MuiButton-containedPrimary': {
      minWidth: '192px',
    },
  },

  [theme.breakpoints.down(400)]: {
    '& .MuiButton-containedPrimary': {
      minWidth: '162px',
      textWrap: 'nowrap',
    },
  },
}));
